module.exports = {["template-constructor-helpers-upload-button"]: function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n\n	<div class="rm-upload-button">\n		<div class="icon"></div>\n	</div>\n\n';
}
return __p;
},}